/**
 * @module components\common-component\RaiseComplaintDialog
 */
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
  name: 'RaiseComplaintDialog',
})
export default class RaiseComplaintDialog extends Vue {
  @Prop(Number) dataLength: number | undefined;
  @Prop(Boolean) raiseDisplay: boolean | false;

  fixedBottom: string = '';
  btnDisplay: boolean = this.raiseDisplay ? this.raiseDisplay : false;
  mode = this.$store.getters.getMode;
  prevRoute = null;
  /* back button function */
  back() {
    let id = this.$route.name;
    this.$router.beforeEach((to, from, next) => {
      next();
    });
    this.$router.go(-1);
    //Google Analytics
    this.$gtag.event('click', {
      event_category: `SelfCare`,
      event_label: 'Back Button Click',
    });
  }

  raiseScreen() {
    let id = this.$route.name;
    this.$router.push({ name: 'HelpRaiseComplaint' });
    //Google Analytics
    this.$gtag.event('click',{
      event_category: `SelfCare`,
      event_label: 'Clicked Raise Complaint Button',
    });
  }

  /*   beforeRouteEnter(to, from, next) {
      next((vm) => {
          vm.prevRoute = from;
      });
      console.log(to, from, next)
  } */

  /* fixed at bottom */
  backButtonFixed() {
    if (this.dataLength >= 15) {
      this.fixedBottom = 'fixed';
    }
  }

  mounted() {
    this.backButtonFixed();
  }
}
